import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LayoutService } from '@common/services/layout.service';

@Component({
  selector: 'collapsible',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss']
})
export class CollapsibleComponent implements OnInit {

  @Input()
  public collapsed: boolean = false;

  @Output()
  public change: EventEmitter<boolean> = new EventEmitter<boolean>();

  public toggle() {

    this.collapsed = !this.collapsed;
    this.change.emit(this.collapsed);
  }

  constructor(private ref: ElementRef, private layout: LayoutService) { }

  ngOnInit(): void {    
  }

}
